import { Input } from "@chakra-ui/react";

import { QuestionWithHeaderAndFooter } from "../question";
import { QuestionContent } from "../question-content";
import { SingleLineQuestionProps } from "../types";

export const SingleLineQuestion = (props: SingleLineQuestionProps) => {
  const {
    spacing,
    isRequired,
    isInvalid,
    className,
    layoutProps,
    labelClassName,
    questionId,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    placeholder,
    size,
    isDisabled,
    changeEventHandler,
    answerProps,
    contentClassName,
    answerAriaLabel,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps
  } = props;

  const headerFooterProps = {
    spacing,
    isRequired,
    isInvalid,
    questionId,
    labelClassName,
    className,
    layoutProps,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <Input
          id={questionId}
          className={contentClassName}
          type="text"
          value={answer}
          placeholder={placeholder}
          onChange={changeEventHandler}
          maxLength={maxLength}
          isDisabled={isDisabled}
          aria-label={answerAriaLabel}
          {...answerProps}
          size={size}
        />
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
